module.exports = __webpack_public_path__ + "img/publish.8574bb92.png";